import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { PopupProps } from '@atlaskit/popup';
import { JiraPopup as Popup } from '@atlassian/jira-popup/src/ui/jira-popup.tsx';
import type { SelectOrPopupTargetRender } from '../types.tsx';

export type ConfigureStatusPopupProps = {
	renderTarget: (props: SelectOrPopupTargetRender) => React.ReactNode;
	renderPopupContent: () => React.ReactNode;
	isTargetEditable: boolean;
	placement: PopupProps['placement'];
	onClose: () => void;
};

export const ConfigureStatusPopup = ({
	renderTarget,
	isTargetEditable,
	placement,
	onClose,
	renderPopupContent,
}: ConfigureStatusPopupProps): React.JSX.Element => {
	return (
		<Popup
			content={() => (
				<Box
					xcss={popupContentStyles}
					role="dialog"
					aria-modal="false"
					aria-labelledby="configure-status-form-popup-header"
				>
					{renderPopupContent()}
				</Box>
			)}
			isOpen
			onClose={onClose}
			placement={placement}
			messageId="issue-field-status.ui.status-view.configure-status.popup"
			messageType="transactional"
			trigger={(triggerProps) =>
				renderTarget({
					isEditable: isTargetEditable,
					isSaving: false,
					targetRef: undefined,
					triggerProps,
				})
			}
			shouldRenderToParent
		/>
	);
};

const popupContentStyles = xcss({
	width: '395px',
});
